// extracted by mini-css-extract-plugin
export default {"titleWrapper":"style_titleWrapper__JooCd"};